import React from "react";
import { X, Info } from "lucide-react";
import Modal from "../../components/Modal/Modal";
import Button from "../../components/Button/Button";

const ViewToggleModal = ({ isOpen, onClose, showChips }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <div className="p-3 rounded-lg border border-[#E4E7EC] bg-white shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]">
              <Info size={24} />
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-2"
              aria-label="Close modal"
            >
              <X size={24} />
            </button>
          </div>

          <h2 className="text-xl font-bold mb-2">View Mode Changed</h2>

          <p className="text-gray-600 mb-4">
            You are now viewing all values in{" "}
            <b>{showChips ? "chips" : "buy-in value"}</b>.{" "}
          </p>
          <div className="w-full">
            <Button onClick={onClose} className="w-full" variant="primary">
              OK
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
);

export default ViewToggleModal;
